import PropTypes from 'prop-types';
import React from 'react';

import {SchemaTag, TAG_SHAPE} from 'folder-items/FileConstants';
import {tryParse} from 'notebook/data-tables/DatetimeFields';
import DatetimeField from 'ui-library/inputs/DatetimeField';
import {DatetimePickerRef} from 'ui-library/inputs/InputConstants';
import {ElementKeyboardEvent} from 'util/Types';

interface DatetimeValueEditorProps {
  autoFocus: boolean;
  defaultValue?: SchemaTag;
  onChange: (value: object) => void;
  onKeyDown?: (e: ElementKeyboardEvent) => void;
  placeholder?: string;
  datePickerPopperContainerSelector?: string;
  wrapperClassName?: string;
  datetimePickerRef?: DatetimePickerRef;
  isDisabled?: boolean;
}

export default function DatetimeValueEditor(props: DatetimeValueEditorProps): JSX.Element {
  const handleChange = (datetimeTextValue: string): void => {
    props.onChange({
      datetimeValue: tryParse(datetimeTextValue),
      value: datetimeTextValue,
    });
  };

  return (
    <DatetimeField
      autoFocus={props.autoFocus}
      labelStyle={DatetimeField.LABEL_STYLES.HIDDEN}
      placeholder={props.placeholder}
      onChange={handleChange}
      onKeyDown={props.onKeyDown}
      value={props.defaultValue ? props.defaultValue.value : null}
      datePickerPopperContainerSelector={props.datePickerPopperContainerSelector}
      wrapperClassName={props.wrapperClassName}
      datetimePickerRef={props.datetimePickerRef}
      isDisabled={props.isDisabled}
    />
  );
}

DatetimeValueEditor.propTypes = {
  autoFocus: PropTypes.bool.isRequired,
  defaultValue: TAG_SHAPE,
  onChange: PropTypes.func.isRequired,
  onKeyDown: PropTypes.func,
  placeholder: PropTypes.string,
};

DatetimeValueEditor.defaultProps = {
  placeholder: 'YYYY-MM-DD hh:mm:ss AM/PM',
};
